import React from "react";

const Loader = ({ size = 40, color = "#2563eb" }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div
        className="animate-spin rounded-full border-4 border-gray-200"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default Loader;
